<app-navmenu />

<main>
  <router-outlet />
</main>

<app-footer />
